import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["row", "controls", "counter", "prevBtn", "nextBtn"]
  static values  = { page: { type: Number, default: 1 }, perPage: { type: Number, default: 15 } }

  connect() {
    this.totalPages = Math.ceil(this.rowTargets.length / this.perPageValue)
    this.update()
  }

  prev() {
    if (this.pageValue > 1) { this.pageValue--; this.update() }
  }

  next() {
    if (this.pageValue < this.totalPages) { this.pageValue++; this.update() }
  }

  update() {
    const start = (this.pageValue - 1) * this.perPageValue
    const end   = start + this.perPageValue

    this.rowTargets.forEach((row, i) => {
      row.classList.toggle("hidden", i < start || i >= end)
    })

    if (this.hasCounterTarget) {
      this.counterTarget.textContent = `${this.pageValue} / ${this.totalPages}`
    }

    if (this.hasPrevBtnTarget) {
      this.prevBtnTarget.disabled = this.pageValue <= 1
    }

    if (this.hasNextBtnTarget) {
      this.nextBtnTarget.disabled = this.pageValue >= this.totalPages
    }
  }
}
